
import axios from "axios";
import { useQuery } from '@tanstack/react-query';
import config from '../../../config.js';
import { useNavigate } from "react-router-dom";

export const useArchivedPatientQuery = ({ caseNumber, LDMCaseNoInt, LDMCaseNoYear }) => {


    const navigate = useNavigate();

    async function fetchArchivedPatient({ queryKey }) {
        const [_key, { caseNumber, LDMCaseNoInt, LDMCaseNoYear }] = queryKey;

        const queryString = new URLSearchParams();

        caseNumber && queryString.set('caseNumber', caseNumber);
        LDMCaseNoInt && queryString.set('LDMCaseNoInt', LDMCaseNoInt);
        LDMCaseNoYear && queryString.set('LDMCaseNoYear', LDMCaseNoYear);


        return await axios.get(`${config.API_URL}/payment/archivedPatient?${queryString.toString()}`, {
            withCredentials: true,
        })

    }



    return useQuery(
        {
            queryKey: ['ArchivedPatient',
                {
                    caseNumber,
                    LDMCaseNoInt,
                    LDMCaseNoYear
                }],
            queryFn: fetchArchivedPatient,
            enabled: !!caseNumber || (!!LDMCaseNoInt && !!LDMCaseNoYear),
            staleTime: 1000 * 60 * 60,
            refetchInterval: 1000 * 60 * 60,

        }
    )





}


